import React from "react";

interface TocItem {
  id: string;
  label: string;
}

interface TableOfContentsProps {
  items: TocItem[];
}

/**
 * TableOfContents Component
 *
 * Displays a sticky table of contents sidebar with anchor links
 * to page sections. Uses the simplified "On this page" style.
 *
 * @param items - Array of { id, label } objects for TOC links
 */
export const TableOfContents: React.FC<TableOfContentsProps> = ({ items }) => {
  return (
    <aside className="toc">
      <div className="toc__title">On this page</div>
      {items.map((item) => (
        <a key={item.id} href={`#${item.id}`} data-depth="1">
          {item.label}
        </a>
      ))}
    </aside>
  );
};
